import { Component, OnInit } from '@angular/core';
import { AppService } from './services/app.service';
import { CustomerService } from 'src/app/services/customer.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { StateService } from './services/states.service';
import { Router } from '@angular/router';
import { RouteEvents } from './guard/router-events';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'cobham';
  tokenauth = "";
  constructor(
    private appService: AppService,
    private cookies: CookieService,
    private stateService: StateService,
    private router: Router,
    private customerService : CustomerService,
    private routeEvents: RouteEvents
  ){}
  ngOnInit(){
    this.appService.getConnectToken().subscribe((token) => {
			environment.tokencsrf = token.result.token;
    });
    this.appService.getEnv().subscribe((env) => {
        environment.BOCC_URL = env.result.BOCC_URL;
        environment.ODOO_URL = env.result.ODOO_URL;
        // environment.COBCAL_URL = env.result.COBCAL_URL;
    });
    environment.tokenauth = this.cookies.get("Tokenauth");
    if(environment.tokenauth){
      this.appService.getUserByToken(this.tokenauth).subscribe((res) => {
        if(res.result.user){
          environment.tokencalc = res.result.token_calc;
          res.result.user.identity.ID = res.result.user.ID;
          res.result.user.identity.email = res.result.user.connection.email;
          //this.router.navigateByUrl("/homepage");
          this.stateService.updateUser(res.result.user.identity);
        }
      });
    }
  }
}
